import { DomainError } from '../errors/domain-error';

export function assertCreatorFollowable(creator: { disabled: boolean } | null): void {
  if (!creator) {
    throw new DomainError('Creator not found');
  }
  if (creator.disabled) {
    throw new DomainError('Creator is not available');
  }
}

export function assertNotAlreadyFollowing(existingFollow: unknown): void {
  if (existingFollow) {
    throw new DomainError('Already following');
  }
}

export function assertIsFollowing(existingFollow: unknown): void {
  if (!existingFollow) {
    throw new DomainError('Not following');
  }
}
